import React from "react";

import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import FadeIn from "react-fade-in";
import Button from "react-bootstrap/Button";

import { IoMdShare } from "react-icons/io";

import { withQueryParams } from "../../common/queryParams";
import { getLink } from "../../common/appLinkBuilder";
import Image from "react-bootstrap/esm/Image";
import { getPlayerApiUrl } from "../../api/apiUrlBuilder";

class ConclusionPage extends React.Component {
  state = {};
  render() {
    const {
      page,
      name,
      data: { tennisPersonality, properties },
      year,
      fadeTimeout,
    } = this.props;
    const { playerId, shared } = this.props.queryParams;

    const shareData = {
      title: `${name}: ${year} tennis year in numbers`,
      text: `Check out ${shared ? `${name}'s` : "my"} ${year} tennis year in numbers`,
      url: `${getPlayerApiUrl()}/go/wrapped/${playerId}?shared=true`,
    };

    return (
      <Container className="mt-5">
        <Row className="mt-2 mb-5">
          <Col>
            <h1>{shared ? `${name}'s ` : "Your"} Tennis Personality</h1>
          </Col>
        </Row>
        <FadeIn delay={fadeTimeout} key={page}>
          <Row className="mt-4">
            <Col>
              <h2 className="text-primary fw-bold ms-n3" style={{ fontSize: "35px" }}>
                {tennisPersonality.name}
              </h2>
            </Col>
          </Row>
          <Row className="mt-1">
            <Col>
              <Image src={getLink(`${tennisPersonality.icon}.png`)} fluid roundedCircle />
            </Col>
            <Col className="text-start">{tennisPersonality.description}</Col>
          </Row>
          {properties.map((p) => (
            <React.Fragment key={p.name}>
              <Row className="mt-3" key={p.name}>
                <Col>
                  <h1 className="text-secondary">{p.name}</h1>
                </Col>
              </Row>
              <Row className="mt-1">
                <Col className="text-start">{p.description}</Col>
              </Row>
            </React.Fragment>
          ))}
          <Row className="mt-3 fs-4">
            <Col>
              {!shared && (
                <Button onClick={async () => await navigator.share(shareData)}>
                  <IoMdShare size="25" /> Share This Story
                </Button>
              )}
              {shared && (
                <React.Fragment>
                  <div className="fs-4">
                    Liked {name}'s story for {year}?
                  </div>
                  <Button className="mt-2" size="lg" variant="primary" href="https://join.ats.tennis" target="_blank">
                    Get ATS in your club
                  </Button>
                </React.Fragment>
              )}
            </Col>
          </Row>
        </FadeIn>
      </Container>
    );
  }
}

export default withQueryParams(ConclusionPage);
